import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';
import { FormsTemplatesListResponse, GetFormsTemplatesParams } from './types';

/**
 * Hook to fetch all form templates with optional filters, search and pagination.
 * `null` disables the fetch until the caller's inputs are ready.
 */
export const useFormsTemplates = (params?: GetFormsTemplatesParams | null) => {
  const query = new URLSearchParams();

  // array params (status, type, key)
  if (params?.status) {
    params?.status?.forEach((s) => query.append('status', s));
  }

  if (params?.type && params.type.length > 0) {
    if (Array.isArray(params.type)) {
      params?.type?.forEach((t) => {
        query.append('type', t);
      });
    } else {
      query.append('type', params.type);
    }
  }

  if (params?.key) {
    params?.key?.forEach((k) => query.append('key', k));
  }

  // search
  if (params?.searchTerm) {
    query.append('searchTerm', params.searchTerm);
  }

  // pagination
  if (params?.limit !== undefined) {
    query.append('limit', params.limit.toString());
  }

  if (params?.offset !== undefined) {
    query.append('offset', params.offset.toString());
  }

  if (params?.hasLiveVersion !== undefined) {
    query.append('hasLiveVersion', String(params.hasLiveVersion));
  }

  const queryString = query.toString();
  const url =
    params === null
      ? null
      : queryString
        ? `${BASE_URL}?${queryString}`
        : BASE_URL;

  const { data, error, isLoading, mutate } = useSWR<FormsTemplatesListResponse>(
    url,
    SWRFetcher({
      method: 'GET',
    })
  );

  const totalCount = data?.count ?? 0;

  return {
    data,
    error,
    isLoading,
    mutate,
    templates: data?.formsTemplates ?? [],
    count: totalCount,
    offset: data?.offset ?? params?.offset ?? 0,
  };
};
